import styled from '@emotion/styled';

export const LogoIcon = styled.img`
  height: 100%;
  width: 100%;
`;
